import {
	APPLICATIONS_MENU_KEY,
	APPLICATIONS_REFERRED_BACK_MENU_KEY,
	APPLICATIONS_SCRUTINY_MENU_KEY,
	APPLICATIONS_SCRUTINIZED_MENU_KEY,
	APPLICATIONS_INSPECTED_MENU_KEY,
	CERTIFICATES_MENU_KEY,
	// CHALLAN_MENU_KEY,
	COMMITTEES_MENU_KEY,
	DASHBOARD_MENU_KEY,
	INSTITUTES_MENU_KEY,
	MEMBERS_MENU_KEY,
	COMMITTEES_MY_MENU_KEY,
	COMMITTEES_HISTORY_MENU_KEY,
	COMMITTEES_REQUESTS_MENU_KEY,
	COURSE_BUILDER_MENU_KEY,
	APPEALS_MENU_KEY,
	CALENDAR_MENU_KEY,
	MANAGE_SESSIONS_MENU_KEY,
	REPORTS_MENU_KEY,
	EMPLOYEE_ENDORSEMENT_MENU_KEY,
	REPORT_MODULE_MENU_KEY,
	TRACEABILITY_MENU_KEY,
	APPLICATIONS_PENDING_REJECTION_MENU_KEY,
	MANAGE_USER_MENU_KEY,
	ROLES_AND_PERMISSIONS_MENU_KEY,
	AUDIT_LOG_MENU_KEY,
	CONFIGURATION_MENU_KEY,
	CONFIGURATION_COURSE_STREAM_MENU_KEY,
	CONFIGURATION_ORGANIZATION_TYPE_MENU_KEY,
	CONFIGURATION_COURSE_CONTENT_MENU_KEY,
	CONFIGURATION_FACULTY_QUALIFICATIONS_MENU_KEY,
	CONFIGURATION_ATTACHMENT_TYPE_MENU_KEY,
	CONFIGURATION_ATTACHMENT_OPTION_MENU_KEY,
	CONFIGURATION_INSTITUTE_FACILITY_MENU_KEY,
	CONFIGURATION_COMPETENCY_POINTS_MENU_KEY,
	CONFIGURATION_SECTORS_MENU_KEY,
	CONFIGURATION_COURSE_SCHEME_MENU_KEY,
	CONFIGURATION_ASSESSMENT_BODY_MENU_KEY,
	FAQ_MENU_KEY,
	UNAUTHORIZED_INSTITUTES_MENU_KEY,
	APPRENTICESHIP_MENU_KEY,
	APPRENTICESHIP_INDUSTRY_MENU_KEY,
	APPRENTICESHIP_APPRENTICES_MENU_KEY,
	APPRENTICESHIP_OUTCOMES_MENU_KEY,
	APPRENTICESHIP_STATISTICS_MENU_KEY,
} from "./menu.keys";
import { getEventManagementMenuItem } from "@features/EventManagement/integration";
import { getCourseAssignMenuItem, getSpecialInitiativeCoursesMenuItem } from "@features/CourseAssign/integration";
import { IS_REPORT_MODULE_NAV_ENABLED } from "@features/ReportModule/reportModule.flags";
import type { TFunction } from "i18next";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import {
	ATTACHMENT_OPTION_CONFIGURATION_PERMISSIONS,
	ATTACHMENT_TYPE_CONFIGURATION_PERMISSIONS,
	CONFIGURATION_SECTION_PERMISSIONS,
	COURSE_CONTENT_CONFIGURATION_PERMISSIONS,
	COURSE_STREAM_CONFIGURATION_PERMISSIONS,
	EXECUTIVE_DASHBOARD_PERMISSIONS,
	INSTITUTE_FACILITY_CONFIGURATION_PERMISSIONS,
	ORGANIZATION_CONFIGURATION_PERMISSIONS,
	PERMISSIONS,
	QUALIFICATION_CONFIGURATION_PERMISSIONS,
	COMPETENCY_POINT_CONFIGURATION_PERMISSIONS,
	SECTOR_CONFIGURATION_PERMISSIONS,
	COURSE_SCHEME_CONFIGURATION_PERMISSIONS,
	ASSESSMENT_BODY_CONFIGURATION_PERMISSIONS,
} from "@constants/user.roles";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import GroupIcon from "@mui/icons-material/Group";
import HistoryIcon from "@mui/icons-material/History";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TraceabilityIcon from "@components/common/Icons/TraceabilityIcon";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";

export const getSidebarMenuConfig = (t: TFunction, options?: { includeEventsRequest?: boolean }) => {
	return [
		{
			key: DASHBOARD_MENU_KEY,
			label: t("layout.sidebar.menuName.dashboard"),
			icon: <WidgetsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
			requiredAnyOfPermissions: [
				PERMISSIONS.PSDA_ADMIN_DASHBOARD,
				PERMISSIONS.CHAIRMAN_PBTE_DASHBOARD,
				...EXECUTIVE_DASHBOARD_PERMISSIONS,
			],
		},
		{
			key: INSTITUTES_MENU_KEY,
			label: t("layout.sidebar.menuName.institutes"),
			icon: <AccountBalanceOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.INSTITUTES,
			requiredPermission: PERMISSIONS.INSTITUTES_LIST,
		},
		{
			key: UNAUTHORIZED_INSTITUTES_MENU_KEY,
			label: t("layout.sidebar.menuName.unauthorizedInstitutes") || "Unauthorized Institutes",
			icon: <GppBadOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.UNAUTHORIZED_INSTITUTE_REPORTS,
			requiredAnyOfPermissions: [PERMISSIONS.UNAUTHORIZED_INSTITUTE_LIST, PERMISSIONS.UNAUTHORIZED_INSTITUTE_VIEW],
		},
		{
			key: TRACEABILITY_MENU_KEY,
			label: t("layout.sidebar.menuName.traceability"),
			icon: <TraceabilityIcon fontSize="medium" />,
			route: BROWSER_ROUTES.TRACEABILITY,
			requiredAnyOfPermissions: [PERMISSIONS.TRACEABILITY_LIST, PERMISSIONS.TRACEABILITY_VIEW],
		},
		{
			key: APPLICATIONS_MENU_KEY,
			label: t("layout.sidebar.menuName.applications"),
			icon: <ArticleOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.APPLICATIONS_SCRUTINY,
			requiredPermission: PERMISSIONS.APPLICATIONS_VIEW,
			children: [
				{
					key: APPLICATIONS_SCRUTINY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.scrutiny"),
					icon: <AssignmentOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPLICATIONS_SCRUTINY,
					requiredPermission: PERMISSIONS.APPLICATIONS_PENDING_LIST,
				},
				{
					key: APPLICATIONS_REFERRED_BACK_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.referredBack"),
					icon: <CancelOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPLICATIONS_REFERRED_BACK,
					requiredPermission: PERMISSIONS.APPLICATIONS_REFERRED_BACK_LIST,
				},
				{
					key: APPLICATIONS_SCRUTINIZED_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.scrutinized"),
					icon: <CheckCircleOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPLICATIONS_SCRUTINIZED,
					requiredPermission: PERMISSIONS.APPLICATIONS_SCRUTINIZED_LIST,
					tooltip: t("layout.sidebar.menuName.subMenu.scrutinizedTooltip"),
				},
				{
					key: APPLICATIONS_INSPECTED_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.inspected"),
					icon: <CheckCircleOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPLICATIONS_INSPECTED,
					requiredAnyOfPermissions: [
						PERMISSIONS.APPLICATIONS_INSPECTED_LIST,
						PERMISSIONS.APPLICATIONS_VERIFIED_LIST,
						PERMISSIONS.APPLICATIONS_APPROVED_LIST,
						PERMISSIONS.ISSUE_CERTIFICATE,
					],
				},
				{
					key: APPLICATIONS_PENDING_REJECTION_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.rejection"),
					icon: <CancelOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPLICATIONS_PENDING_REJECTION,
					// No requiredPermission on parent – visible when any child list permission is present
					children: [
						{
							key: `${APPLICATIONS_PENDING_REJECTION_MENU_KEY}-pending`,
							label: t("layout.sidebar.menuName.subMenu.pending"),
							icon: <PendingOutlinedIcon fontSize="small" />,
							route: `${BROWSER_ROUTES.APPLICATIONS_PENDING_REJECTION}?status=pending`,
							requiredPermission: PERMISSIONS.APPLICATION_REJECTION_PENDING_LIST,
						},
						{
							key: `${APPLICATIONS_PENDING_REJECTION_MENU_KEY}-approved`,
							label: t("layout.sidebar.menuName.subMenu.approvedRejection"),
							icon: <CheckCircleOutlinedIcon fontSize="small" />,
							route: `${BROWSER_ROUTES.APPLICATIONS_PENDING_REJECTION}?status=approved`,
							requiredPermission: PERMISSIONS.APPLICATION_REJECTION_APPROVED_LIST,
						},
						{
							key: `${APPLICATIONS_PENDING_REJECTION_MENU_KEY}-rejected`,
							label: t("layout.sidebar.menuName.subMenu.rejectedRejection"),
							icon: <CancelOutlinedIcon fontSize="small" />,
							route: `${BROWSER_ROUTES.APPLICATIONS_PENDING_REJECTION}?status=rejected`,
							requiredPermission: PERMISSIONS.APPLICATION_REJECTION_REJECTED_LIST,
						},
						{
							key: `${APPLICATIONS_PENDING_REJECTION_MENU_KEY}-cancel`,
							label: t("layout.sidebar.menuName.subMenu.cancel"),
							icon: <BlockOutlinedIcon fontSize="small" />,
							route: `${BROWSER_ROUTES.APPLICATIONS_PENDING_REJECTION}?status=cancel`,
							requiredPermission: PERMISSIONS.APPLICATION_REJECTION_CANCELLED_LIST,
						},
					],
				},
				{
					key: APPEALS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.appeals"),
					icon: <AssignmentOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPEALS,
					requiredAnyOfPermissions: [PERMISSIONS.APPLICATION_APPEAL_VIEW, PERMISSIONS.APPLICATION_APPEAL_PENDING_LIST],
				},
			],
		},
		{
			key: COMMITTEES_MENU_KEY,
			label: t("layout.sidebar.menuName.committees"),
			icon: <Diversity3OutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.COMMITTEES,
			children: [
				{
					key: COMMITTEES_MY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.myCommittee"),
					icon: <GroupIcon fontSize="small" />,
					route: BROWSER_ROUTES.COMMITTEES_MY,
					requiredAnyOfPermissions: [
						PERMISSIONS.MY_COMMITTEE_PENDING_APPROVAL_LIST,
						PERMISSIONS.MY_COMMITTEE_CONSTITUTED_LIST,
						PERMISSIONS.MY_COMMITTEE_APPROVED_LIST,
						PERMISSIONS.MY_COMMITTEE_REJECTED_LIST,
					],
				},
				{
					key: COMMITTEES_REQUESTS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.requests"),
					icon: <AssignmentIndIcon fontSize="small" />,
					route: BROWSER_ROUTES.COMMITTEES_REQUESTS,
					requiredPermission: PERMISSIONS.REQUESTS_LISTS,
				},
				{
					key: COMMITTEES_HISTORY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.history"),
					icon: <HistoryIcon fontSize="small" />,
					route: BROWSER_ROUTES.COMMITTEES_HISTORY,
					requiredAnyOfPermissions: [
						PERMISSIONS.HISTORY_CONSTITUTED_LIST,
						PERMISSIONS.HISTORY_APPROVED_LIST,
						PERMISSIONS.HISTORY_REJECT_LIST,
					],
				},
			],
		},
		{
			key: CERTIFICATES_MENU_KEY,
			label: t("layout.sidebar.menuName.certificates"),
			icon: <FactCheckOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.CERTIFICATES,
			requiredAnyOfPermissions: [PERMISSIONS.CERTIFICATES_VIEW, PERMISSIONS.CERTIFICATES_LIST],
		},
		{
			key: MEMBERS_MENU_KEY,
			label: t("layout.sidebar.menuName.members"),
			icon: <PeopleAltOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MEMBERS,
			requiredPermission: PERMISSIONS.COMMITTEE_MEMBER_LIST_READ,
		},
		{
			key: COURSE_BUILDER_MENU_KEY,
			label: t("layout.sidebar.menuName.courseBuilder"),
			icon: <BuildOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.COURSE_BUILDER,
			requiredAnyOfPermissions: [PERMISSIONS.COURSES_LIST, PERMISSIONS.LABS_LIST, PERMISSIONS.EQUIPMENTS_LIST],
		},
		{
			key: CALENDAR_MENU_KEY,
			label: t("layout.sidebar.menuName.calendar"),
			icon: <CalendarMonthOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.CALENDAR,
			requiredAnyOfPermissions: [PERMISSIONS.ANNUAL_CALENDAR_VIEW, PERMISSIONS.ANNUAL_CALENDAR_LIST],
		},
		getEventManagementMenuItem(t, {
			includeEventsRequest: options?.includeEventsRequest,
		}),
		getCourseAssignMenuItem(t),
		getSpecialInitiativeCoursesMenuItem(t),
		{
			key: MANAGE_SESSIONS_MENU_KEY,
			label: t("layout.sidebar.menuName.manageSessions"),
			icon: <EventNoteOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MANAGE_SESSIONS,
			requiredAnyOfPermissions: [PERMISSIONS.MANAGE_SESSIONS_LIST, PERMISSIONS.MANAGE_SESSIONS_VIEW],
		},
		{
			key: REPORTS_MENU_KEY,
			label: t("layout.sidebar.menuName.reports"),
			icon: <AssessmentOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.REPORTS,
			requiredPermission: PERMISSIONS.REPORTS_VIEW,
		},
		{
			key: EMPLOYEE_ENDORSEMENT_MENU_KEY,
			label: t("layout.sidebar.menuName.employeeEndorsement"),
			icon: <BadgeOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.EMPLOYEE_ENDORSEMENT,
			requiredPermission: PERMISSIONS.EMPLOYER_LIST,
			requireExplicitPermission: true,
		},
		...(IS_REPORT_MODULE_NAV_ENABLED
			? [
					{
						key: REPORT_MODULE_MENU_KEY,
						label: t("layout.sidebar.menuName.reportModule"),
						icon: <TableChartOutlinedIcon fontSize="medium" />,
						route: BROWSER_ROUTES.REPORT_MODULE,
						requiredAnyOfPermissions: [PERMISSIONS.CHAIRMAN_TEVTA_DASHBOARD],
					},
				]
			: []),
		{
			key: APPRENTICESHIP_MENU_KEY,
			label: t("layout.sidebar.menuName.apprenticeship"),
			icon: <WorkOutlineIcon fontSize="medium" />,
			route: BROWSER_ROUTES.APPRENTICESHIP_INDUSTRY,
			requiredAnyOfPermissions: [
				PERMISSIONS.APPRENTICESHIP_DASHBOARD_SUMMARY,
				PERMISSIONS.APPRENTICESHIP_INDUSTRY_LIST,
				PERMISSIONS.APPRENTICESHIP_INDUSTRY_VIEW,
				PERMISSIONS.APPRENTICESHIP_APPRENTICE_LIST,
				PERMISSIONS.APPRENTICESHIP_APPRENTICE_VIEW,
				PERMISSIONS.APPRENTICESHIP_OUTCOMES_LIST,
				PERMISSIONS.APPRENTICESHIP_OUTCOMES_VIEW,
			],
			children: [
				{
					key: APPRENTICESHIP_STATISTICS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.statistics"),
					icon: <AssessmentOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPRENTICESHIP_STATISTICS,
					requiredPermission: PERMISSIONS.APPRENTICESHIP_DASHBOARD_SUMMARY,
				},
				{
					key: APPRENTICESHIP_INDUSTRY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.industry"),
					icon: <FactoryOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPRENTICESHIP_INDUSTRY,
					requiredAnyOfPermissions: [
						PERMISSIONS.APPRENTICESHIP_INDUSTRY_LIST,
						PERMISSIONS.APPRENTICESHIP_INDUSTRY_VIEW,
					],
				},
				{
					key: APPRENTICESHIP_APPRENTICES_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.apprentices"),
					icon: <SchoolOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPRENTICESHIP_APPRENTICES,
					requiredAnyOfPermissions: [
						PERMISSIONS.APPRENTICESHIP_APPRENTICE_LIST,
						PERMISSIONS.APPRENTICESHIP_APPRENTICE_VIEW,
					],
				},
				{
					key: APPRENTICESHIP_OUTCOMES_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.completionTraceability"),
					icon: <FactCheckOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.APPRENTICESHIP_OUTCOMES,
					/** Same visibility as Apprentices: outcomes-specific perms OR apprentice list/view */
					requiredAnyOfPermissions: [
						PERMISSIONS.APPRENTICESHIP_OUTCOMES_LIST,
						PERMISSIONS.APPRENTICESHIP_OUTCOMES_VIEW,
						PERMISSIONS.APPRENTICESHIP_APPRENTICE_LIST,
						PERMISSIONS.APPRENTICESHIP_APPRENTICE_VIEW,
					],
				},
			],
		},
		// {
		// 	key: CHALLAN_MENU_KEY,
		// 	label: t("layout.sidebar.menuName.challan"),
		// 	icon: <GradingOutlinedIcon fontSize="medium" />,
		// 	route: BROWSER_ROUTES.CHALLAN,
		// 	requiredPermission: PERMISSIONS.ALL_READ,
		// },
		{
			key: MANAGE_USER_MENU_KEY,
			label: t("layout.sidebar.menuName.manageUsers"),
			icon: <ManageAccountsIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MANAGE_USERS,
			requiredAnyOfPermissions: [PERMISSIONS.MANAGE_USERS_LIST, PERMISSIONS.MANAGE_USERS_VIEW],
		},
		{
			key: ROLES_AND_PERMISSIONS_MENU_KEY,
			label: t("layout.sidebar.menuName.rolesAndPermissions"),
			icon: <SecurityOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.ROLES_AND_PERMISSIONS,
			requiredAnyOfPermissions: [PERMISSIONS.ROLES_LIST, PERMISSIONS.ROLES_VIEW],
		},
		{
			key: AUDIT_LOG_MENU_KEY,
			label: t("layout.sidebar.menuName.auditLog"),
			icon: <HistoryIcon fontSize="medium" />,
			route: BROWSER_ROUTES.AUDIT_LOGS,
			requiredPermission: PERMISSIONS.AUDIT_LOGS_VIEW,
		},
		{
			key: CONFIGURATION_MENU_KEY,
			label: t("layout.sidebar.menuName.configuration"),
			icon: <SettingsOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.CONFIGURATION_COURSE_STREAM,
			requiredAnyOfPermissions: [...CONFIGURATION_SECTION_PERMISSIONS],
			children: [
				{
					key: CONFIGURATION_COURSE_STREAM_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.courseStreamConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_COURSE_STREAM,
					requiredAnyOfPermissions: [...COURSE_STREAM_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_ORGANIZATION_TYPE_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.organizationTypeConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_ORGANIZATION_TYPE,
					requiredAnyOfPermissions: [...ORGANIZATION_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_COURSE_CONTENT_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.courseContentConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_COURSE_CONTENT,
					requiredAnyOfPermissions: [...COURSE_CONTENT_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_FACULTY_QUALIFICATIONS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.facultyQualifications"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_FACULTY_QUALIFICATIONS,
					requiredAnyOfPermissions: [...QUALIFICATION_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_ATTACHMENT_TYPE_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.attachmentTypeConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_ATTACHMENT_TYPE,
					requiredAnyOfPermissions: [...ATTACHMENT_TYPE_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_ATTACHMENT_OPTION_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.attachmentOptionConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_ATTACHMENT_OPTION,
					requiredAnyOfPermissions: [...ATTACHMENT_OPTION_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_INSTITUTE_FACILITY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.instituteFacility"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_INSTITUTE_FACILITY,
					requiredAnyOfPermissions: [...INSTITUTE_FACILITY_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_COMPETENCY_POINTS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.competencyPoints"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_COMPETENCY_POINTS,
					requiredAnyOfPermissions: [...COMPETENCY_POINT_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_SECTORS_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.sectors"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_SECTORS,
					requiredAnyOfPermissions: [...SECTOR_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_ASSESSMENT_BODY_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.assessmentBodyConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_ASSESSMENT_BODY,
					requiredAnyOfPermissions: [...ASSESSMENT_BODY_CONFIGURATION_PERMISSIONS],
				},
				{
					key: CONFIGURATION_COURSE_SCHEME_MENU_KEY,
					label: t("layout.sidebar.menuName.subMenu.courseSchemeConfiguration"),
					icon: <SettingsOutlinedIcon fontSize="small" />,
					route: BROWSER_ROUTES.CONFIGURATION_COURSE_SCHEME,
					requiredAnyOfPermissions: [...COURSE_SCHEME_CONFIGURATION_PERMISSIONS],
				},
			],
		},
		{
			key: FAQ_MENU_KEY,
			label: t("layout.sidebar.menuName.faq") || "FAQ Management",
			icon: <HelpOutlineIcon fontSize="medium" />,
			route: BROWSER_ROUTES.FAQ_SECTIONS,
			requiredPermission: PERMISSIONS.FAQS_LIST,
		},
	];
};
